import { useMemo } from 'react'
import s from './CompanyClients.scss'
import { KeyValuePairs } from 'components/ideal-core-ui'
import { Container, Row } from 'reactstrap'
import { Header } from './Header'
import { Contacts } from './Contacts'
import { PaginatedSelect } from 'components/common/PaginatedSelect'
import { toCompaniesSelect } from 'components/Companies/serializers'
import { sortClientsByAwarded } from 'utils/helpers'
import cn from 'classnames'

const CompanyClients = ({
  changeClientContacts,
  entity,
  changeClientProperty,
  changeContactIsMain,
  withRoles,
  changeClientContactRole,
  refreshClientContacts,
  defaultOptions,
  defaultAction,
  id,
  isClearable,
  customStyles,
  withDates = true,
  style,
  clientsSelectClass,
  withContactDetails = true,
  selectKey,
  withEmailContact = false,
  withSaveEmailAsNote = false,
  components,
  awardedCompany,
  withInvitedToBid = false
}) => {
  const selectedClients = useMemo(() => {
    return sortClientsByAwarded(entity.clients, awardedCompany)
  }, [entity.clients, awardedCompany])

  return (
    <div style={style} className={s.clientsWrapper}>
      <KeyValuePairs
        pairs={[
          {
            key: '*Client(s)',
            keyClass: [s.clientsLabel],
            value: (
              <PaginatedSelect
                url="/v1/companies"
                className={cn(s.clients, {
                  [clientsSelectClass]: clientsSelectClass
                })}
                value={selectedClients}
                onChange={value => changeClientContacts(value)}
                isMulti
                serializer={toCompaniesSelect}
                defaultOptions={defaultOptions}
                defaultAction={defaultAction}
                isPortal
                id={id}
                isClearable={isClearable}
                customStyles={customStyles}
                selectKey={selectKey}
                components={components}
              />
            )
          }
        ]}
      />
      {selectedClients &&
        selectedClients.map((client, index) => (
          <Container key={client.value}>
            <Row className={s.clientRow} data-cy={`client-row-${index}`}>
              <Header
                withDates={withDates}
                date={client.dueDate || entity.dueDate}
                followUpDate={client.followUpDate}
                client={client}
                index={index}
                refreshClientContacts={refreshClientContacts}
                changeClientProperty={changeClientProperty}
                cy="contacts_select_cy"
                awardedCompany={awardedCompany}
                withInvitedToBid={withInvitedToBid}
              />
              {withContactDetails &&
                client.selectedContacts &&
                !!client.selectedContacts.length && (
                  <Contacts
                    withRoles={withRoles}
                    clientIndex={index}
                    changeContactIsMain={changeContactIsMain}
                    changeClientContactRole={changeClientContactRole}
                    contacts={client.selectedContacts}
                    withEmailContact={withEmailContact}
                    entity={entity}
                    clientId={client.value}
                    withSaveEmailAsNote={withSaveEmailAsNote}
                  />
                )}
            </Row>
          </Container>
        ))}
    </div>
  )
}

export default CompanyClients
